import Constants from "src/utils/constants";
import Exception from "src/utils/exception";
import DBOperationsComb from "src/utils/dbOperationsComb";

async function insertEmail(data) {
  try {
    return await DBOperationsComb.insertData(
      Constants.enums.TABLES_NAME_ENUM.EMAIL_QUEUE_TABLE,
      data,
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  insertEmail
};
